export const headerDatalocator = {
    cca_header_back_button_testid: 'cca-header-back-button',
    cca_header_help_modal_button_testid: 'cca-header-help-modal-button',
    cca_header_exit_modal_button_testid: 'cca-header-exit-modal-button', 
    cca_header_title_testid:'cca-header-title' ,
    cca_exit_modal_title_testid:'cca-exit-modal-title',
    cca_help_modal_title_testid: 'cca-help-modal-title',
};